import { useCallback } from 'react'

import { BodySubtext } from '@/components/atomic/text'
import Tooltip from '@/components/atomic/tooltip'

import { Checkbox as BaseCheckbox } from './base'

export interface CheckboxProps {
  checked?: boolean | 'indeterminate'
  disabled?: boolean
  /** Optional callback for when the checked state changes.
   * This callback should not attempt to update checkbox state,
   * since it is handled internally by the component. */
  onCheckedChange?: (value: boolean | 'indeterminate') => void
  label?: string
  tooltipText?: string
}

/**
 * @deprecated Use `Checkbox` from `@moment/design-system-ui/checkbox` instead.
 */
// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default function Checkbox({
  checked = false,
  disabled = false,
  onCheckedChange,
  label,
  tooltipText,
}: CheckboxProps) {
  const onCheckedChangeCallback = useCallback(
    (value: boolean | 'indeterminate') => {
      if (disabled || !onCheckedChange) {
        return
      }

      onCheckedChange(value)
    },
    [onCheckedChange, disabled],
  )
  const checkbox = (
    <BaseCheckbox
      checked={checked}
      onCheckedChange={onCheckedChangeCallback}
      disabled={disabled}
    />
  )

  const tooltipContent = tooltipText?.includes('\n') ? (
    <div className="flex flex-col gap-1">
      {tooltipText.split('\n').map((line, index) => (
        <BodySubtext key={index}>{line}</BodySubtext>
      ))}
    </div>
  ) : undefined

  return (
    <div className="flex items-center gap-2">
      {tooltipText ? (
        <Tooltip
          simpleText={tooltipContent ? undefined : tooltipText}
          customContent={tooltipContent}
          side="top"
        >
          {checkbox}
        </Tooltip>
      ) : (
        checkbox
      )}
      {label && (
        <BodySubtext color="text-moment-teal-text">{label}</BodySubtext>
      )}
    </div>
  )
}
